import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "pos-right" }
const _hoisted_2 = { class: "row gx-xxl-6 px-3 pt-2" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "form-group mb-20" }
const _hoisted_5 = {
  class: "d-block text-secondary fw-bold text-uppercase mb-2",
  style: {"font-size":"11px","letter-spacing":"0.5px"}
}
const _hoisted_6 = { value: null }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-lg-6" }
const _hoisted_9 = { class: "form-group mb-20" }
const _hoisted_10 = {
  class: "d-block text-secondary fw-bold text-uppercase mb-2",
  style: {"font-size":"11px","letter-spacing":"0.5px"}
}
const _hoisted_11 = { value: null }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "card border-0 shadow-none rounded-1 mb-3 bg-transparent" }
const _hoisted_14 = { class: "total-summary px-xl-4 px-3 border-top pt-4" }
const _hoisted_15 = {
  key: 0,
  class: "promotion-auto-card mb-3"
}
const _hoisted_16 = { class: "promotion-auto-kicker" }
const _hoisted_17 = { class: "promotion-auto-value" }
const _hoisted_18 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_19 = { class: "fs-13 text-secondary fw-semibold" }
const _hoisted_20 = { class: "fs-14 fw-bold text-dark" }
const _hoisted_21 = ["data-bs-toggle", "data-bs-target"]
const _hoisted_22 = { class: "fs-13 text-secondary fw-semibold d-flex align-items-center gap-2" }
const _hoisted_23 = {
  key: 0,
  class: "ri-edit-line text-primary"
}
const _hoisted_24 = {
  key: 1,
  class: "auto-pill"
}
const _hoisted_25 = { class: "fs-14 fw-bold text-danger" }
const _hoisted_26 = { class: "fs-13 text-secondary fw-semibold d-flex align-items-center gap-2" }
const _hoisted_27 = { class: "fs-14 fw-bold text-danger" }
const _hoisted_28 = { class: "fs-13 text-secondary fw-semibold d-flex align-items-center gap-2" }
const _hoisted_29 = { class: "fs-14 fw-bold text-dark" }
const _hoisted_30 = { class: "fs-13 text-secondary fw-semibold d-flex align-items-center gap-2" }
const _hoisted_31 = { class: "fs-14 fw-bold text-dark" }
const _hoisted_32 = { class: "grand-total-box bg-primary-subtle rounded-4 p-3 d-flex justify-content-between align-items-center mb-4 mt-2" }
const _hoisted_33 = { class: "text-primary fw-bold text-uppercase fs-14" }
const _hoisted_34 = {
  class: "text-primary fw-bolder",
  style: {"font-size":"26px"}
}
const _hoisted_35 = { class: "payment-grid mb-4" }
const _hoisted_36 = { class: "text-white" }
const _hoisted_37 = { class: "action-grid pb-2" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "bill-launch-copy" }
const _hoisted_40 = {
  class: "modal fade",
  id: "suspendedSalesModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_41 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_42 = { class: "modal-content border-0 shadow" }
const _hoisted_43 = { class: "modal-header bg-primary text-white border-0" }
const _hoisted_44 = { class: "modal-title fw-bold text-white" }
const _hoisted_45 = { class: "modal-body p-4" }
const _hoisted_46 = { class: "table-responsive" }
const _hoisted_47 = { class: "table table-hover align-middle mb-0" }
const _hoisted_48 = { class: "bg-light" }
const _hoisted_49 = { class: "text-end" }
const _hoisted_50 = { class: "text-end" }
const _hoisted_51 = { class: "text-end" }
const _hoisted_52 = { class: "text-end" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { key: 0 }
const _hoisted_55 = {
  colspan: "6",
  class: "text-center py-4 text-muted"
}
const _hoisted_56 = {
  class: "modal fade",
  id: "discountModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_57 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_58 = { class: "modal-content border-0 shadow" }
const _hoisted_59 = { class: "modal-header bg-primary text-white border-0" }
const _hoisted_60 = { class: "modal-title fw-bold text-white" }
const _hoisted_61 = { class: "modal-body p-4" }
const _hoisted_62 = { class: "form-group mb-3" }
const _hoisted_63 = { class: "form-label fw-bold" }
const _hoisted_64 = { value: "fixed" }
const _hoisted_65 = { value: "percentage" }
const _hoisted_66 = { class: "form-group mb-3" }
const _hoisted_67 = { class: "form-label fw-bold" }
const _hoisted_68 = { class: "modal-footer border-0 pt-0" }
const _hoisted_69 = {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}
const _hoisted_70 = {
  class: "modal fade",
  id: "couponModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_71 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_72 = { class: "modal-content border-0 shadow" }
const _hoisted_73 = { class: "modal-header bg-primary text-white border-0" }
const _hoisted_74 = { class: "modal-title fw-bold text-white" }
const _hoisted_75 = { class: "modal-body p-4" }
const _hoisted_76 = { class: "form-group mb-3" }
const _hoisted_77 = { class: "form-label fw-bold" }
const _hoisted_78 = { value: null }
const _hoisted_79 = ["value"]
const _hoisted_80 = { class: "modal-footer border-0 pt-0" }
const _hoisted_81 = {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}
const _hoisted_82 = {
  class: "modal fade",
  id: "taxModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_83 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_84 = { class: "modal-content border-0 shadow" }
const _hoisted_85 = { class: "modal-header bg-primary text-white border-0" }
const _hoisted_86 = { class: "modal-title fw-bold text-white" }
const _hoisted_87 = { class: "modal-body p-4" }
const _hoisted_88 = { class: "form-group mb-3" }
const _hoisted_89 = { class: "form-label fw-bold" }
const _hoisted_90 = { class: "modal-footer border-0 pt-0" }
const _hoisted_91 = {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}
const _hoisted_92 = {
  class: "modal fade",
  id: "shippingModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_93 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_94 = { class: "modal-content border-0 shadow" }
const _hoisted_95 = { class: "modal-header bg-primary text-white border-0" }
const _hoisted_96 = { class: "modal-title fw-bold text-white" }
const _hoisted_97 = { class: "modal-body p-4" }
const _hoisted_98 = { class: "form-group mb-3" }
const _hoisted_99 = { class: "form-label fw-bold" }
const _hoisted_100 = { class: "modal-footer border-0 pt-0" }
const _hoisted_101 = {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}
const _hoisted_102 = {
  class: "modal fade",
  id: "checkoutConfirmModal",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_103 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_104 = { class: "modal-content border-0 rounded-4 shadow-lg overflow-hidden" }
const _hoisted_105 = { class: "modal-header bg-light border-0 px-4 py-3 position-relative" }
const _hoisted_106 = { class: "modal-title fw-bold text-dark d-flex align-items-center gap-2" }
const _hoisted_107 = { class: "modal-body p-0" }
const _hoisted_108 = { class: "row g-0" }
const _hoisted_109 = { class: "col-md-5 bg-light border-end p-4 d-flex flex-column h-100" }
const _hoisted_110 = {
  class: "fw-bold text-secondary text-uppercase mb-3 fs-12",
  style: {"letter-spacing":"1px"}
}
const _hoisted_111 = {
  class: "table-responsive flex-grow-1",
  style: {"max-height":"280px"}
}
const _hoisted_112 = { class: "table table-borderless table-sm mb-0" }
const _hoisted_113 = { class: "text-dark fw-medium px-0 py-2" }
const _hoisted_114 = {
  class: "text-truncate",
  style: {"max-width":"160px"}
}
const _hoisted_115 = { class: "text-muted fs-12" }
const _hoisted_116 = {
  key: 0,
  class: "text-warning-emphasis fs-11 fw-semibold mt-1"
}
const _hoisted_117 = { class: "text-end fw-bold text-dark px-0 py-2 align-middle fs-14" }
const _hoisted_118 = { class: "border-top pt-3 mt-3" }
const _hoisted_119 = { class: "d-flex justify-content-between mb-2 text-muted fs-13" }
const _hoisted_120 = {
  key: 0,
  class: "d-flex justify-content-between mb-2 text-muted fs-13"
}
const _hoisted_121 = { class: "text-danger" }
const _hoisted_122 = {
  key: 1,
  class: "d-flex justify-content-between mb-2 text-muted fs-13"
}
const _hoisted_123 = {
  key: 2,
  class: "d-flex justify-content-between mb-2 text-muted fs-13"
}
const _hoisted_124 = { class: "d-flex justify-content-between align-items-center mt-3 pt-3 border-top border-dark border-opacity-10" }
const _hoisted_125 = { class: "fw-bold text-dark" }
const _hoisted_126 = { class: "fw-bolder text-primary fs-20" }
const _hoisted_127 = { class: "col-md-7 p-4 bg-white" }
const _hoisted_128 = { class: "d-flex align-items-center justify-content-between mb-4" }
const _hoisted_129 = { class: "fw-bold text-dark mb-0 fs-15" }
const _hoisted_130 = { class: "badge bg-primary-subtle text-primary border border-primary border-opacity-25 px-3 py-2 rounded-pill fw-bold text-uppercase d-flex align-items-center gap-1 shadow-sm" }
const _hoisted_131 = { class: "mb-4 position-relative" }
const _hoisted_132 = {
  class: "form-label text-secondary fw-bold fs-12 text-uppercase mb-2",
  style: {"letter-spacing":"0.5px"}
}
const _hoisted_133 = { class: "position-relative d-flex align-items-center" }
const _hoisted_134 = { class: "position-absolute ms-3 z-1" }
const _hoisted_135 = { class: "text-primary fw-bolder fs-20" }
const _hoisted_136 = ["disabled"]
const _hoisted_137 = {
  key: 0,
  class: "membership-card-panel mb-4"
}
const _hoisted_138 = {
  class: "form-label text-secondary fw-bold fs-12 text-uppercase mb-2",
  style: {"letter-spacing":"0.5px"}
}
const _hoisted_139 = {
  key: 0,
  class: "membership-card-summary mt-3"
}
const _hoisted_140 = { class: "membership-card-summary-row" }
const _hoisted_141 = { class: "membership-card-summary-row" }
const _hoisted_142 = { class: "membership-card-summary-row" }
const _hoisted_143 = { class: "membership-card-summary-row" }
const _hoisted_144 = {
  key: 1,
  class: "alert alert-danger border-0 py-2 px-3 mt-3 mb-0"
}
const _hoisted_145 = {
  key: 2,
  class: "alert alert-warning border-0 py-2 px-3 mt-3 mb-0"
}
const _hoisted_146 = {
  key: 1,
  class: "d-flex flex-wrap gap-2 mb-4"
}
const _hoisted_147 = ["onClick"]
const _hoisted_148 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_149 = { class: "d-flex align-items-center gap-2" }
const _hoisted_150 = { class: "fw-semibold text-dark" }
const _hoisted_151 = { class: "d-flex gap-2 mt-4 pt-2" }
const _hoisted_152 = ["disabled"]
const _hoisted_153 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_154 = {
  key: 1,
  class: "ri-checkbox-circle-line fs-20"
}
const _hoisted_155 = {
  class: "modal fade bill-modal",
  id: "invoiceModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_156 = { class: "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_157 = { class: "modal-content border-0 shadow-lg bill-modal-content" }
const _hoisted_158 = { class: "modal-header border-0 bill-modal-header" }
const _hoisted_159 = { class: "bill-modal-eyebrow" }
const _hoisted_160 = { class: "modal-title fw-bold mb-1" }
const _hoisted_161 = { class: "bill-modal-caption mb-0" }
const _hoisted_162 = { class: "modal-body p-0 bill-modal-body" }
const _hoisted_163 = {
  key: 0,
  class: "bill-loading-state"
}
const _hoisted_164 = { class: "fw-bold mb-2" }
const _hoisted_165 = { class: "text-muted mb-0" }
const _hoisted_166 = {
  key: 1,
  class: "row g-0"
}
const _hoisted_167 = { class: "col-lg-5 bill-summary-column" }
const _hoisted_168 = { class: "bill-summary-wrap" }
const _hoisted_169 = { class: "bill-summary-hero" }
const _hoisted_170 = { class: "bill-summary-label" }
const _hoisted_171 = { class: "mb-2" }
const _hoisted_172 = { class: "mb-0" }
const _hoisted_173 = { class: "bill-chip-row" }
const _hoisted_174 = { class: "bill-stat-grid" }
const _hoisted_175 = { class: "bill-stat-card" }
const _hoisted_176 = { class: "bill-stat-title" }
const _hoisted_177 = { class: "bill-stat-card" }
const _hoisted_178 = { class: "bill-stat-title" }
const _hoisted_179 = {
  key: 0,
  class: "bill-stat-card"
}
const _hoisted_180 = { class: "bill-stat-title" }
const _hoisted_181 = { class: "bill-stat-card" }
const _hoisted_182 = { class: "bill-stat-title" }
const _hoisted_183 = { class: "bill-stat-card" }
const _hoisted_184 = { class: "bill-stat-title" }
const _hoisted_185 = { class: "bill-detail-card" }
const _hoisted_186 = { class: "bill-detail-row" }
const _hoisted_187 = { class: "bill-detail-row" }
const _hoisted_188 = {
  key: 0,
  class: "bill-detail-row"
}
const _hoisted_189 = { class: "bill-detail-row" }
const _hoisted_190 = { class: "bill-detail-row" }
const _hoisted_191 = {
  key: 1,
  class: "bill-detail-row"
}
const _hoisted_192 = {
  key: 0,
  class: "bill-note-card"
}
const _hoisted_193 = { class: "bill-note-label" }
const _hoisted_194 = { class: "mb-0" }
const _hoisted_195 = { class: "col-lg-7 bill-preview-column" }
const _hoisted_196 = { class: "bill-preview-shell" }
const _hoisted_197 = {
  class: "bill-paper",
  id: "printableInvoice"
}
const _hoisted_198 = { class: "bill-paper-header" }
const _hoisted_199 = { class: "bill-paper-kicker" }
const _hoisted_200 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_201 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_202 = {
  key: 2,
  class: "mb-0"
}
const _hoisted_203 = { class: "bill-paper-meta" }
const _hoisted_204 = { class: "bill-paper-meta-card" }
const _hoisted_205 = { class: "bill-paper-meta-label" }
const _hoisted_206 = { class: "bill-paper-meta-card text-lg-end" }
const _hoisted_207 = { class: "bill-paper-meta-label" }
const _hoisted_208 = {
  key: 0,
  class: "bill-paper-reference"
}
const _hoisted_209 = {
  key: 1,
  class: "bill-paper-reference"
}
const _hoisted_210 = { class: "table-responsive" }
const _hoisted_211 = { class: "bill-paper-table" }
const _hoisted_212 = { class: "text-center" }
const _hoisted_213 = { class: "text-end" }
const _hoisted_214 = { class: "text-end" }
const _hoisted_215 = { class: "fw-semibold" }
const _hoisted_216 = { class: "text-center" }
const _hoisted_217 = { class: "text-end" }
const _hoisted_218 = { class: "text-end fw-semibold" }
const _hoisted_219 = { class: "bill-paper-totals" }
const _hoisted_220 = { class: "bill-paper-total-row" }
const _hoisted_221 = {
  key: 0,
  class: "bill-paper-total-row text-danger"
}
const _hoisted_222 = {
  key: 1,
  class: "bill-paper-total-row text-danger"
}
const _hoisted_223 = {
  key: 2,
  class: "bill-paper-total-row"
}
const _hoisted_224 = {
  key: 3,
  class: "bill-paper-total-row"
}
const _hoisted_225 = { class: "bill-paper-total-row is-grand" }
const _hoisted_226 = { class: "bill-paper-total-row" }
const _hoisted_227 = { class: "bill-paper-total-row" }
const _hoisted_228 = { class: "bill-paper-total-row" }
const _hoisted_229 = { class: "bill-paper-footer" }
const _hoisted_230 = {
  key: 0,
  class: "bill-paper-note"
}
const _hoisted_231 = { class: "bill-paper-powered mb-0" }
const _hoisted_232 = {
  key: 2,
  class: "bill-empty-state"
}
const _hoisted_233 = { class: "fw-bold mb-2" }
const _hoisted_234 = { class: "text-muted mb-0" }
const _hoisted_235 = { class: "modal-footer border-0 bill-modal-footer" }
const _hoisted_236 = {
  type: "button",
  class: "btn btn-light border",
  "data-bs-dismiss": "modal"
}
const _hoisted_237 = ["disabled"]
const _hoisted_238 = {
  class: "modal fade",
  id: "openRegisterModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_239 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_240 = { class: "modal-content border-0 shadow" }
const _hoisted_241 = { class: "modal-header bg-primary text-white border-0" }
const _hoisted_242 = { class: "modal-title fw-bold text-white" }
const _hoisted_243 = { class: "modal-body p-4" }
const _hoisted_244 = { class: "row" }
const _hoisted_245 = { class: "col-md-5 border-end" }
const _hoisted_246 = { class: "form-group mb-3" }
const _hoisted_247 = { class: "form-label fw-bold" }
const _hoisted_248 = { class: "input-group" }
const _hoisted_249 = { class: "text-muted" }
const _hoisted_250 = ["disabled"]
const _hoisted_251 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_252 = { class: "col-md-7" }
const _hoisted_253 = { class: "fw-bold mb-3" }
const _hoisted_254 = {
  class: "table-responsive",
  style: {"max-height":"300px"}
}
const _hoisted_255 = { class: "table table-sm table-hover fs-13" }
const _hoisted_256 = { class: "bg-light" }
const _hoisted_257 = { class: "text-end" }
const _hoisted_258 = { key: 0 }
const _hoisted_259 = { key: 1 }
const _hoisted_260 = { class: "text-end fw-bold text-primary" }
const _hoisted_261 = { key: 0 }
const _hoisted_262 = {
  colspan: "4",
  class: "text-center text-muted py-3"
}
const _hoisted_263 = {
  class: "modal fade",
  id: "closeRegisterModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_264 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_265 = { class: "modal-content border-0 shadow" }
const _hoisted_266 = { class: "modal-header bg-danger text-white border-0" }
const _hoisted_267 = { class: "modal-title fw-bold text-white" }
const _hoisted_268 = { class: "modal-body p-4" }
const _hoisted_269 = { class: "bg-light rounded-2 p-3 mb-4" }
const _hoisted_270 = { class: "fw-bold border-bottom pb-2 mb-3" }
const _hoisted_271 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_272 = { class: "text-muted" }
const _hoisted_273 = { class: "fw-bold text-dark" }
const _hoisted_274 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_275 = { class: "text-muted" }
const _hoisted_276 = { class: "fw-bold text-success" }
const _hoisted_277 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_278 = { class: "text-muted" }
const _hoisted_279 = { class: "fw-bold text-info" }
const _hoisted_280 = { class: "d-flex justify-content-between mb-2 border-bottom pb-2" }
const _hoisted_281 = { class: "text-muted" }
const _hoisted_282 = { class: "fw-bold text-danger" }
const _hoisted_283 = { class: "d-flex justify-content-between mt-2 pt-1" }
const _hoisted_284 = { class: "fw-bold" }
const _hoisted_285 = { class: "fw-bold text-primary fs-16" }
const _hoisted_286 = { class: "form-group mb-3" }
const _hoisted_287 = { class: "form-label fw-bold" }
const _hoisted_288 = { class: "input-group" }
const _hoisted_289 = { class: "form-group mb-0" }
const _hoisted_290 = { class: "form-label fw-bold" }
const _hoisted_291 = ["placeholder"]
const _hoisted_292 = { class: "modal-footer border-0 pt-0" }
const _hoisted_293 = {
  type: "button",
  class: "btn btn-light fw-medium",
  "data-bs-dismiss": "modal"
}
const _hoisted_294 = ["disabled"]
const _hoisted_295 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectedProducts = _resolveComponent("SelectedProducts")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["prevent"])),
      class: "pb-60"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("pos.customer")), 1),
            _withDirectives(_createElementVNode("select", {
              class: "form-select bg-white border rounded-pill fs-13 py-2 text-dark shadow-sm",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCustomerId) = $event))
            }, [
              _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$t("pos.walk_in_customer")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customers, (c) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: c.id,
                  value: c.id
                }, _toDisplayString(c.name), 9, _hoisted_7))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedCustomerId]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("pos.biller")), 1),
            _withDirectives(_createElementVNode("select", {
              class: "form-select bg-white border rounded-pill fs-13 py-2 text-dark shadow-sm",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedBillerId) = $event))
            }, [
              _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t("pos.choose_biller")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billers, (b) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: b.id,
                  value: b.id
                }, _toDisplayString(b.name), 9, _hoisted_12))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedBillerId]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_SelectedProducts)
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_ctx.activePromotion)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("pos.auto_promotion")), 1),
                _createElementVNode("strong", null, _toDisplayString(_ctx.activePromotion.name), 1),
                _createElementVNode("small", null, _toDisplayString(_ctx.activePromotionSummary), 1)
              ]),
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.activePromotionValueLabel), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("pos.total_item")) + " (" + _toDisplayString(_ctx.totalItems) + ")", 1),
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.subTotal)), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["d-flex justify-content-between align-items-center mb-2 cursor-pointer dropdown-toggle-container", { 'locked-discount-row': !!_ctx.activePromotion }]),
          "data-bs-toggle": _ctx.activePromotion ? null : 'modal',
          "data-bs-target": _ctx.activePromotion ? null : '#discountModal',
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDiscountRowClick && _ctx.handleDiscountRowClick(...args)))
        }, [
          _createElementVNode("span", _hoisted_22, [
            _createTextVNode(_toDisplayString(_ctx.activePromotion ? _ctx.activePromotion.name : _ctx.$t('pos.discount')) + " ", 1),
            (!_ctx.activePromotion)
              ? (_openBlock(), _createElementBlock("i", _hoisted_23))
              : (_openBlock(), _createElementBlock("small", _hoisted_24, _toDisplayString(_ctx.$t("pos.auto_promotion")), 1))
          ]),
          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.discountType === 'percentage' ? '-' + _ctx.discount + '%' : _ctx.discount > 0 ? '-' + _ctx.stateStore.formatPrice(_ctx.discount) : '-' + _ctx.stateStore.formatPrice(0)), 1)
        ], 10, _hoisted_21),
        _createElementVNode("div", {
          class: "d-flex justify-content-between align-items-center mb-2 cursor-pointer dropdown-toggle-container",
          "data-bs-toggle": "modal",
          "data-bs-target": "#couponModal",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openCouponModal && _ctx.openCouponModal(...args)))
        }, [
          _createElementVNode("span", _hoisted_26, [
            _createTextVNode(_toDisplayString(_ctx.$t("pos.coupon")) + " ", 1),
            _cache[39] || (_cache[39] = _createElementVNode("i", { class: "ri-edit-line text-primary" }, null, -1))
          ]),
          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.couponDiscount > 0 ? '-' + _ctx.stateStore.formatPrice(_ctx.couponDiscount) : '-' + _ctx.stateStore.formatPrice(0)), 1)
        ]),
        _createElementVNode("div", {
          class: "d-flex justify-content-between align-items-center mb-2 cursor-pointer dropdown-toggle-container",
          "data-bs-toggle": "modal",
          "data-bs-target": "#taxModal",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openTaxModal && _ctx.openTaxModal(...args)))
        }, [
          _createElementVNode("span", _hoisted_28, [
            _createTextVNode(_toDisplayString(_ctx.$t("pos.tax")) + " (" + _toDisplayString(_ctx.taxRate > 0 ? _ctx.taxRate + '%' : '0%') + ") ", 1),
            _cache[40] || (_cache[40] = _createElementVNode("i", { class: "ri-edit-line text-primary" }, null, -1))
          ]),
          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.orderTax)), 1)
        ]),
        _createElementVNode("div", {
          class: "d-flex justify-content-between align-items-center mb-3 cursor-pointer dropdown-toggle-container",
          "data-bs-toggle": "modal",
          "data-bs-target": "#shippingModal",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openShippingModal && _ctx.openShippingModal(...args)))
        }, [
          _createElementVNode("span", _hoisted_30, [
            _createTextVNode(_toDisplayString(_ctx.$t("pos.shipping")) + " ", 1),
            _cache[41] || (_cache[41] = _createElementVNode("i", { class: "ri-edit-line text-primary" }, null, -1))
          ]),
          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.shippingCost)), 1)
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("pos.grand_total")), 1),
          _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.totalCost)), 1)
        ]),
        _createElementVNode("div", _hoisted_35, [
          (_ctx.canUseMembershipCard)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "payment-btn",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.prepareCheckout('card'))),
                "data-bs-toggle": "modal",
                "data-bs-target": "#checkoutConfirmModal"
              }, [
                _cache[42] || (_cache[42] = _createElementVNode("i", { class: "ri-bank-card-line text-primary fs-24 mb-1" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.card")), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "payment-btn",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.prepareCheckout('cash'))),
            "data-bs-toggle": "modal",
            "data-bs-target": "#checkoutConfirmModal"
          }, [
            _cache[43] || (_cache[43] = _createElementVNode("i", { class: "ri-money-dollar-circle-line text-primary fs-24 mb-1" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.cash")), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "payment-btn",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.prepareCheckout('khqr'))),
            "data-bs-toggle": "modal",
            "data-bs-target": "#checkoutConfirmModal"
          }, [...(_cache[44] || (_cache[44] = [
            _createElementVNode("i", { class: "ri-qr-scan-2-line text-primary fs-24 mb-1" }, null, -1),
            _createElementVNode("span", null, "KHQR", -1)
          ]))]),
          _createElementVNode("button", {
            type: "button",
            class: "payment-btn pay-btn bg-primary border-primary justify-content-center align-items-center",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.prepareCheckout('cash'))),
            "data-bs-toggle": "modal",
            "data-bs-target": "#checkoutConfirmModal"
          }, [
            _cache[45] || (_cache[45] = _createElementVNode("i", { class: "ri-shopping-cart-2-line text-white fs-24 mb-1" }, null, -1)),
            _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t("pos.pay")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("button", {
            type: "button",
            class: "action-btn text-danger bg-danger-subtle",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args)))
          }, [
            _cache[46] || (_cache[46] = _createElementVNode("i", { class: "ri-restart-line me-2 fs-16" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("pos.reset")), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "action-btn text-warning",
            style: {"background-color":"#fff8e1"},
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleSuspend && _ctx.handleSuspend(...args)))
          }, [
            _cache[47] || (_cache[47] = _createElementVNode("i", { class: "ri-pause-line me-2 fs-16" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("pos.suspend")), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "action-btn text-dark bg-light border",
            "data-bs-toggle": "modal",
            "data-bs-target": "#suspendedSalesModal",
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.fetchSuspendedSales && _ctx.fetchSuspendedSales(...args)))
          }, [
            _cache[48] || (_cache[48] = _createElementVNode("i", { class: "ri-list-check me-2 fs-16" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("pos.list")), 1)
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "bill-launch-btn mt-3",
          "data-bs-toggle": "modal",
          "data-bs-target": "#invoiceModal",
          disabled: !_ctx.lastSaleData
        }, [
          _createElementVNode("span", _hoisted_39, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("pos.view_bill")), 1),
            _createElementVNode("small", null, _toDisplayString(_ctx.lastSaleData ? _ctx.$t('pos.latest_reference', { reference: _ctx.lastSaleData.reference_no }) : _ctx.$t('pos.complete_sale_to_open_latest_bill')), 1)
          ]),
          _cache[49] || (_cache[49] = _createElementVNode("i", { class: "ri-receipt-line fs-20" }, null, -1))
        ], 8, _hoisted_38)
      ])
    ], 32),
    _cache[68] || (_cache[68] = _createElementVNode("button", {
      id: "openInvoiceBtn",
      type: "button",
      class: "d-none",
      "data-bs-toggle": "modal",
      "data-bs-target": "#invoiceModal"
    }, null, -1)),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("h5", _hoisted_44, _toDisplayString(_ctx.$t("pos.suspended_sales")), 1),
            _cache[50] || (_cache[50] = _createElementVNode("button", {
              type: "button",
              class: "btn-close btn-close-white",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("table", _hoisted_47, [
                _createElementVNode("thead", _hoisted_48, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("pos.date")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("pos.reference")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("pos.customer")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("pos.items")), 1),
                    _createElementVNode("th", _hoisted_49, _toDisplayString(_ctx.$t("pos.total")), 1),
                    _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.$t("common.action")), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suspendedSales, (sale) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: sale.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(new Date(sale.created_at).toLocaleDateString()), 1),
                      _createElementVNode("td", null, _toDisplayString(sale.reference_no), 1),
                      _createElementVNode("td", null, _toDisplayString(sale.customer_name || sale.customer?.name || _ctx.$t('pos.walk_in')), 1),
                      _createElementVNode("td", null, _toDisplayString(sale.items?.length || 0), 1),
                      _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.stateStore.formatPrice(Number(sale.total || 0))), 1),
                      _createElementVNode("td", _hoisted_52, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-primary",
                          onClick: ($event: any) => (_ctx.resumeSuspend(sale)),
                          "data-bs-dismiss": "modal"
                        }, _toDisplayString(_ctx.$t("pos.resume")), 9, _hoisted_53)
                      ])
                    ]))
                  }), 128)),
                  (_ctx.suspendedSales.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_54, [
                        _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.$t("pos.no_suspended_sales_found")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_56, [
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("h5", _hoisted_60, _toDisplayString(_ctx.$t("pos.apply_discount")), 1),
            _cache[51] || (_cache[51] = _createElementVNode("button", {
              type: "button",
              class: "btn-close btn-close-white",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.$t("pos.discount_type")), 1),
              _withDirectives(_createElementVNode("select", {
                class: "form-select border border-secondary border-opacity-25",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.tempDiscountType) = $event))
              }, [
                _createElementVNode("option", _hoisted_64, _toDisplayString(_ctx.$t("pos.fixed_amount")), 1),
                _createElementVNode("option", _hoisted_65, _toDisplayString(_ctx.$t("pos.percentage")), 1)
              ], 512), [
                [_vModelSelect, _ctx.tempDiscountType]
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.$t("pos.discount_value")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control border border-secondary border-opacity-25",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.tempDiscount) = $event)),
                min: "0",
                step: "0.01"
              }, null, 512), [
                [_vModelText, _ctx.tempDiscount]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("button", _hoisted_69, _toDisplayString(_ctx.$t("common.cancel")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.applyDiscount && _ctx.applyDiscount(...args)))
            }, _toDisplayString(_ctx.$t("common.apply")), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_70, [
      _createElementVNode("div", _hoisted_71, [
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("h5", _hoisted_74, _toDisplayString(_ctx.$t("pos.apply_coupon")), 1),
            _cache[52] || (_cache[52] = _createElementVNode("button", {
              type: "button",
              class: "btn-close btn-close-white",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.$t("pos.select_coupon")), 1),
              _withDirectives(_createElementVNode("select", {
                class: "form-select border-0 shadow-sm rounded-pill",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.tempCouponCode) = $event)),
                onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.handleCouponSelection && _ctx.handleCouponSelection(...args)))
              }, [
                _createElementVNode("option", _hoisted_78, _toDisplayString(_ctx.$t("pos.select_coupon_placeholder")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coupons, (coupon) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: coupon.id,
                    value: coupon.code
                  }, _toDisplayString(coupon.name) + " (" + _toDisplayString(coupon.code) + ") ", 9, _hoisted_79))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.tempCouponCode]
              ])
            ]),
            (_ctx.couponMessage)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["alert mt-3", _ctx.isCouponValid ? 'alert-success' : 'alert-danger'])
                }, _toDisplayString(_ctx.couponMessage), 3))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.removeCoupon && _ctx.removeCoupon(...args)))
            }, _toDisplayString(_ctx.$t("pos.remove_coupon")), 1),
            _createElementVNode("button", _hoisted_81, _toDisplayString(_ctx.$t("common.close")), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_82, [
      _createElementVNode("div", _hoisted_83, [
        _createElementVNode("div", _hoisted_84, [
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("h5", _hoisted_86, _toDisplayString(_ctx.$t("pos.order_tax")), 1),
            _cache[53] || (_cache[53] = _createElementVNode("button", {
              type: "button",
              class: "btn-close btn-close-white",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("label", _hoisted_89, _toDisplayString(_ctx.$t("pos.tax_rate")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control border border-secondary border-opacity-25",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.tempTaxRate) = $event)),
                min: "0",
                step: "0.01"
              }, null, 512), [
                [_vModelText, _ctx.tempTaxRate]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("button", _hoisted_91, _toDisplayString(_ctx.$t("common.cancel")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.applyTax && _ctx.applyTax(...args)))
            }, _toDisplayString(_ctx.$t("common.apply")), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_92, [
      _createElementVNode("div", _hoisted_93, [
        _createElementVNode("div", _hoisted_94, [
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("h5", _hoisted_96, _toDisplayString(_ctx.$t("pos.shipping_cost")), 1),
            _cache[54] || (_cache[54] = _createElementVNode("button", {
              type: "button",
              class: "btn-close btn-close-white",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("label", _hoisted_99, _toDisplayString(_ctx.$t("pos.shipping_amount")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control border border-secondary border-opacity-25",
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.tempShippingCost) = $event)),
                min: "0",
                step: "0.01"
              }, null, 512), [
                [_vModelText, _ctx.tempShippingCost]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_100, [
            _createElementVNode("button", _hoisted_101, _toDisplayString(_ctx.$t("common.cancel")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.applyShipping && _ctx.applyShipping(...args)))
            }, _toDisplayString(_ctx.$t("common.apply")), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_102, [
      _createElementVNode("div", _hoisted_103, [
        _createElementVNode("div", _hoisted_104, [
          _createElementVNode("div", _hoisted_105, [
            _createElementVNode("h5", _hoisted_106, [
              _cache[55] || (_cache[55] = _createElementVNode("div", {
                class: "bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center",
                style: {"width":"32px","height":"32px"}
              }, [
                _createElementVNode("i", { class: "ri-secure-payment-line fs-18" })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("pos.checkout_confirmation")), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close bg-secondary bg-opacity-10 rounded-circle p-2",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.cancelCheckout && _ctx.cancelCheckout(...args)))
            })
          ]),
          _createElementVNode("div", _hoisted_107, [
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("div", _hoisted_109, [
                _createElementVNode("h6", _hoisted_110, _toDisplayString(_ctx.$t("pos.order_summary")), 1),
                _createElementVNode("div", _hoisted_111, [
                  _createElementVNode("table", _hoisted_112, [
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stateStore.selectedProducts, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.id
                        }, [
                          _createElementVNode("td", _hoisted_113, [
                            _createElementVNode("div", _hoisted_114, _toDisplayString(item.name), 1),
                            _createElementVNode("div", _hoisted_115, _toDisplayString(_ctx.stateStore.formatPrice(item.price)) + " × " + _toDisplayString(item.qty), 1),
                            (_ctx.getProductPromotionLabel(item))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_116, _toDisplayString(_ctx.getProductPromotionLabel(item)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_117, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.getProductLineTotal(item))), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_118, [
                  _createElementVNode("div", _hoisted_119, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.items")) + " (" + _toDisplayString(_ctx.totalItems) + ")", 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.subTotal)), 1)
                  ]),
                  (_ctx.discount > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.discount")), 1),
                        _createElementVNode("span", _hoisted_121, "-" + _toDisplayString(_ctx.discountType === 'percentage' ? _ctx.discount + '%' : _ctx.stateStore.formatPrice(_ctx.discount)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.orderTax > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.tax")) + " (" + _toDisplayString(_ctx.taxRate) + "%)", 1),
                        _createElementVNode("span", null, "+" + _toDisplayString(_ctx.stateStore.formatPrice(_ctx.orderTax)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.shippingCost > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.shipping")), 1),
                        _createElementVNode("span", null, "+" + _toDisplayString(_ctx.stateStore.formatPrice(_ctx.shippingCost)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_124, [
                    _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.$t("pos.total")), 1),
                    _createElementVNode("span", _hoisted_126, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.totalCost)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_127, [
                _createElementVNode("div", _hoisted_128, [
                  _createElementVNode("h6", _hoisted_129, _toDisplayString(_ctx.$t("pos.payment_details")), 1),
                  _createElementVNode("span", _hoisted_130, [
                    _cache[56] || (_cache[56] = _createElementVNode("i", { class: "ri-wallet-3-fill fs-14" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.activePaymentMethodLabel), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_131, [
                  _createElementVNode("label", _hoisted_132, _toDisplayString(_ctx.pendingPaymentMethod === 'cash' ? _ctx.$t('pos.amount_received') : _ctx.$t('pos.payment_amount')), 1),
                  _createElementVNode("div", _hoisted_133, [
                    _createElementVNode("div", _hoisted_134, [
                      _createElementVNode("span", _hoisted_135, _toDisplayString(_ctx.stateStore.currencySymbol), 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control form-control-lg border-2 fw-bolder text-dark ps-5 shadow-none rounded-3",
                      style: {"font-size":"28px","height":"64px","background-color":"#f8fafc","transition":"all 0.2s","border-color":"#e2e8f0"},
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.cashReceived) = $event)),
                      placeholder: "0.00",
                      step: "0.01",
                      disabled: _ctx.pendingPaymentMethod !== 'cash',
                      onFocus: _cache[26] || (_cache[26] = ($event: any) => (($event.target as HTMLInputElement).select())),
                      onfocus: "this.style.borderColor='#3b82f6'; this.style.backgroundColor='#fff'; this.style.boxShadow='0 0 0 0.25rem rgba(59, 130, 246, 0.1)'",
                      onblur: "this.style.borderColor='#e2e8f0'; this.style.backgroundColor='#f8fafc'; this.style.boxShadow='none'"
                    }, null, 40, _hoisted_136), [
                      [_vModelText, _ctx.cashReceived]
                    ])
                  ])
                ]),
                (_ctx.pendingPaymentMethod === 'card')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                      _createElementVNode("label", _hoisted_138, _toDisplayString(_ctx.$t("pos.membership_card")), 1),
                      _createVNode(_component_a_select, {
                        value: _ctx.selectedMembershipCardValue,
                        "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.selectedMembershipCardValue) = $event)),
                        class: "membership-card-select",
                        size: "large",
                        "show-search": "",
                        "allow-clear": "",
                        options: _ctx.membershipCardOptions,
                        "option-filter-prop": "label",
                        disabled: !_ctx.availableMembershipCards.length,
                        placeholder: _ctx.$t('pos.membership_card_search_placeholder'),
                        "get-popup-container": _ctx.getMembershipCardPopupContainer
                      }, null, 8, ["value", "options", "disabled", "placeholder", "get-popup-container"]),
                      (_ctx.selectedMembershipCard)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                            _createElementVNode("div", _hoisted_140, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.card_number")), 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.selectedMembershipCard.card_number), 1)
                            ]),
                            _createElementVNode("div", _hoisted_141, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.customer")), 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.selectedMembershipCard.customer_name || _ctx.selectedMembershipCard.customer?.name || _ctx.$t('pos.general_walk_in_customer')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_142, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.available_balance")), 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.stateStore.formatPrice(Number(_ctx.selectedMembershipCard.balance || 0))), 1)
                            ]),
                            _createElementVNode("div", _hoisted_143, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.balance_after_payment")), 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.membershipCardRemainingBalance)), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.membershipCardError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_144, _toDisplayString(_ctx.membershipCardError), 1))
                        : (!_ctx.availableMembershipCards.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_145, _toDisplayString(_ctx.$t("pos.no_active_membership_cards")), 1))
                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.pendingPaymentMethod === 'cash')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 5, 10, 20, 50, 100], (amount) => {
                        return _createElementVNode("button", {
                          key: amount,
                          type: "button",
                          class: "btn btn-outline-secondary border-opacity-50 btn-sm rounded-pill px-3 fw-bold flex-grow-1",
                          style: {"transition":"background-color 0.2s"},
                          onClick: ($event: any) => (_ctx.cashReceived = (Number(_ctx.cashReceived) || 0) + amount)
                        }, " +" + _toDisplayString(_ctx.stateStore.currencySymbol) + _toDisplayString(amount), 9, _hoisted_147)
                      }), 64)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn bg-primary text-white border-0 btn-sm rounded-pill px-3 fw-bold flex-grow-1",
                        style: {"transition":"none"},
                        onmouseover: "this.style.backgroundColor='var(--bs-primary)'",
                        onmouseout: "this.style.backgroundColor='var(--bs-primary)'",
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.cashReceived = _ctx.totalCost))
                      }, _toDisplayString(_ctx.$t("pos.exact")), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-light text-danger border-0 btn-sm rounded-pill px-3 fw-bold flex-grow-1 bg-danger-subtle",
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.cashReceived = 0))
                      }, _toDisplayString(_ctx.$t("pos.clear")), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["p-3 rounded-4 mb-4", _ctx.changeAmount > 0 ? 'bg-success bg-opacity-10 border border-success border-opacity-25' : 'bg-light border'])
                }, [
                  _createElementVNode("div", _hoisted_148, [
                    _createElementVNode("div", _hoisted_149, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["rounded-circle d-flex align-items-center justify-content-center", _ctx.changeAmount > 0 ? 'bg-success text-white' : 'bg-secondary bg-opacity-25 text-secondary']),
                        style: {"width":"32px","height":"32px"}
                      }, [...(_cache[57] || (_cache[57] = [
                        _createElementVNode("i", { class: "ri-exchange-dollar-line fs-16" }, null, -1)
                      ]))], 2),
                      _createElementVNode("span", _hoisted_150, _toDisplayString(_ctx.$t("pos.change_return")), 1)
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["fw-bolder fs-24", _ctx.changeAmount > 0 ? 'text-success' : 'text-secondary'])
                    }, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.changeAmount)), 3)
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_151, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light btn-lg fw-bold flex-grow-1 border rounded-3",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.cancelCheckout && _ctx.cancelCheckout(...args)))
                  }, _toDisplayString(_ctx.$t("common.cancel")), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary btn-lg fw-bold flex-grow-1 shadow-sm d-flex align-items-center justify-content-center gap-2 rounded-3",
                    style: {"min-width":"60%"},
                    onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.confirmCheckout && _ctx.confirmCheckout(...args))),
                    disabled: _ctx.isCheckoutDisabled
                  }, [
                    (_ctx.isSubmitting)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_153))
                      : (_openBlock(), _createElementBlock("i", _hoisted_154)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("pos.confirm_and_pay")), 1)
                  ], 8, _hoisted_152)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_155, [
      _createElementVNode("div", _hoisted_156, [
        _createElementVNode("div", _hoisted_157, [
          _createElementVNode("div", _hoisted_158, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_159, _toDisplayString(_ctx.$t("pos.pos_sale_completed")), 1),
              _createElementVNode("h5", _hoisted_160, _toDisplayString(_ctx.$t("pos.view_bill")), 1),
              _createElementVNode("p", _hoisted_161, _toDisplayString(_ctx.$t("pos.review_final_receipt")), 1)
            ]),
            _cache[58] || (_cache[58] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_162, [
            (_ctx.invoiceLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                  _cache[59] || (_cache[59] = _createElementVNode("div", {
                    class: "spinner-border text-primary mb-3",
                    role: "status"
                  }, null, -1)),
                  _createElementVNode("h6", _hoisted_164, _toDisplayString(_ctx.$t("pos.preparing_bill_preview")), 1),
                  _createElementVNode("p", _hoisted_165, _toDisplayString(_ctx.$t("pos.loading_saved_sale")), 1)
                ]))
              : (_ctx.lastSaleData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                    _createElementVNode("div", _hoisted_167, [
                      _createElementVNode("div", _hoisted_168, [
                        _createElementVNode("div", _hoisted_169, [
                          _createElementVNode("span", _hoisted_170, _toDisplayString(_ctx.$t("pos.receipt_reference")), 1),
                          _createElementVNode("h3", _hoisted_171, _toDisplayString(_ctx.lastSaleData.reference_no), 1),
                          _createElementVNode("p", _hoisted_172, _toDisplayString(_ctx.$t("pos.sale_saved_successfully")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_173, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["bill-chip", `is-${_ctx.getBillTone(_ctx.lastSaleData.status)}`])
                          }, _toDisplayString(_ctx.formatStatusLabel(_ctx.lastSaleData.status)), 3),
                          _createElementVNode("span", {
                            class: _normalizeClass(["bill-chip bill-chip-outline", `is-${_ctx.getBillTone(_ctx.lastSaleData.payment_status)}`])
                          }, _toDisplayString(_ctx.formatStatusLabel(_ctx.lastSaleData.payment_status)), 3)
                        ]),
                        _createElementVNode("div", _hoisted_174, [
                          _createElementVNode("div", _hoisted_175, [
                            _createElementVNode("span", _hoisted_176, _toDisplayString(_ctx.$t("pos.grand_total")), 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.lastSaleData.grand_total)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_177, [
                            _createElementVNode("span", _hoisted_178, _toDisplayString(_ctx.$t("pos.items")), 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.getBillItemsCount(_ctx.lastSaleData)), 1)
                          ]),
                          (_ctx.getBillQueueLabel(_ctx.lastSaleData))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                                _createElementVNode("span", _hoisted_180, _toDisplayString(_ctx.$t("pos.waiting_no")), 1),
                                _createElementVNode("strong", null, "#" + _toDisplayString(_ctx.getBillQueueLabel(_ctx.lastSaleData)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_181, [
                            _createElementVNode("span", _hoisted_182, _toDisplayString(_ctx.$t("pos.amount_received")), 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.lastSaleData.cash_received)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_183, [
                            _createElementVNode("span", _hoisted_184, _toDisplayString(_ctx.lastSaleData.due > 0 ? _ctx.$t('pos.balance_due') : _ctx.$t('pos.change_return')), 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.lastSaleData.due > 0 ? _ctx.lastSaleData.due : _ctx.lastSaleData.change_amount)), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_185, [
                          _createElementVNode("div", _hoisted_186, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.customer")), 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.lastSaleData.customer_name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_187, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.warehouse")), 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.lastSaleData.warehouse_name), 1)
                          ]),
                          (_ctx.lastSaleData.biller_name)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_188, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.biller")), 1),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.lastSaleData.biller_name), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_189, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.payment_method")), 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.formatPaymentMethod(_ctx.lastSaleData.paid_by)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_190, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.sale_date")), 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.lastSaleData.date), 1)
                          ]),
                          (_ctx.getBillQueueLabel(_ctx.lastSaleData))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_191, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.waiting_ticket")), 1),
                                _createElementVNode("strong", null, " #" + _toDisplayString(_ctx.getBillQueueLabel(_ctx.lastSaleData)) + " · " + _toDisplayString(_ctx.formatStatusLabel(_ctx.lastSaleData.queue_status || "pending")), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.stateStore.receiptSettings.showNoteToCustomer)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_192, [
                              _createElementVNode("span", _hoisted_193, _toDisplayString(_ctx.$t("pos.customer_note")), 1),
                              _createElementVNode("p", _hoisted_194, _toDisplayString(_ctx.stateStore.receiptSettings.noteToCustomer), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_195, [
                      _createElementVNode("div", _hoisted_196, [
                        _createElementVNode("div", _hoisted_197, [
                          _cache[60] || (_cache[60] = _createElementVNode("div", { class: "bill-paper-accent" }, null, -1)),
                          _createElementVNode("div", _hoisted_198, [
                            _createElementVNode("div", _hoisted_199, _toDisplayString(_ctx.$t("pos.customer_copy")), 1),
                            _createElementVNode("h2", null, _toDisplayString(_ctx.stateStore.siteName), 1),
                            (_ctx.stateStore.receiptSettings.showAddress && _ctx.stateStore.companyAddress)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_200, _toDisplayString(_ctx.stateStore.companyAddress), 1))
                              : _createCommentVNode("", true),
                            (_ctx.stateStore.receiptSettings.showPhone && _ctx.stateStore.companyPhone)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_201, _toDisplayString(_ctx.stateStore.companyPhone), 1))
                              : _createCommentVNode("", true),
                            (_ctx.stateStore.receiptSettings.showEmail && _ctx.stateStore.companyEmail)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_202, _toDisplayString(_ctx.stateStore.companyEmail), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_203, [
                            _createElementVNode("div", _hoisted_204, [
                              _createElementVNode("span", _hoisted_205, _toDisplayString(_ctx.$t("pos.receipt")), 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.lastSaleData.reference_no), 1),
                              _createElementVNode("small", null, _toDisplayString(_ctx.lastSaleData.date), 1)
                            ]),
                            _createElementVNode("div", _hoisted_206, [
                              _createElementVNode("span", _hoisted_207, _toDisplayString(_ctx.$t("pos.customer")), 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.lastSaleData.customer_name), 1),
                              _createElementVNode("small", null, _toDisplayString(_ctx.lastSaleData.warehouse_name), 1)
                            ])
                          ]),
                          (_ctx.getBillQueueLabel(_ctx.lastSaleData))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_208, _toDisplayString(_ctx.$t("pos.waiting_number")) + " #" + _toDisplayString(_ctx.getBillQueueLabel(_ctx.lastSaleData)) + " · " + _toDisplayString(_ctx.formatStatusLabel(_ctx.lastSaleData.queue_status || "pending")), 1))
                            : _createCommentVNode("", true),
                          (_ctx.stateStore.receiptSettings.showBarcode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_209, _toDisplayString(_ctx.lastSaleData.reference_no), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_210, [
                            _createElementVNode("table", _hoisted_211, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("pos.description")), 1),
                                  _createElementVNode("th", _hoisted_212, _toDisplayString(_ctx.$t("pos.qty")), 1),
                                  _createElementVNode("th", _hoisted_213, _toDisplayString(_ctx.$t("pos.price")), 1),
                                  _createElementVNode("th", _hoisted_214, _toDisplayString(_ctx.$t("pos.total")), 1)
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lastSaleData.items, (item) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: item.id
                                  }, [
                                    _createElementVNode("td", _hoisted_215, _toDisplayString(item.product_name), 1),
                                    _createElementVNode("td", _hoisted_216, _toDisplayString(item.quantity), 1),
                                    _createElementVNode("td", _hoisted_217, _toDisplayString(_ctx.stateStore.formatPrice(item.unit_price)), 1),
                                    _createElementVNode("td", _hoisted_218, _toDisplayString(_ctx.stateStore.formatPrice(item.total)), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_219, [
                            _createElementVNode("div", _hoisted_220, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.subtotal")), 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.lastSaleData.total)), 1)
                            ]),
                            (_ctx.stateStore.receiptSettings.showTaxDiscount && _ctx.getDirectDiscount(_ctx.lastSaleData) > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_221, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.discount")), 1),
                                  _createElementVNode("strong", null, "-" + _toDisplayString(_ctx.stateStore.formatPrice(_ctx.getDirectDiscount(_ctx.lastSaleData))), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.stateStore.receiptSettings.showTaxDiscount && _ctx.lastSaleData.coupon_discount > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_222, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.coupon")), 1),
                                  _createElementVNode("strong", null, "-" + _toDisplayString(_ctx.stateStore.formatPrice(_ctx.lastSaleData.coupon_discount)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.stateStore.receiptSettings.showTaxDiscount && _ctx.lastSaleData.tax > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_223, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.order_tax")), 1),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.lastSaleData.tax)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.stateStore.receiptSettings.showTaxDiscount && _ctx.lastSaleData.shipping > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.shipping")), 1),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.lastSaleData.shipping)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_225, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.grand_total")), 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.lastSaleData.grand_total)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_226, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.amount_received")), 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.lastSaleData.cash_received)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_227, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.change")), 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.stateStore.formatPrice(_ctx.lastSaleData.change_amount)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_228, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.payment_method")), 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.formatPaymentMethod(_ctx.lastSaleData.paid_by)), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_229, [
                            (_ctx.stateStore.receiptSettings.showNoteToCustomer)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_230, _toDisplayString(_ctx.stateStore.receiptSettings.noteToCustomer), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_231, _toDisplayString(_ctx.$t("pos.powered_by", { name: _ctx.stateStore.siteName })), 1)
                          ])
                        ])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_232, [
                    _cache[61] || (_cache[61] = _createElementVNode("div", { class: "bill-empty-icon" }, [
                      _createElementVNode("i", { class: "ri-receipt-line" })
                    ], -1)),
                    _createElementVNode("h6", _hoisted_233, _toDisplayString(_ctx.$t("pos.no_bill_available_yet")), 1),
                    _createElementVNode("p", _hoisted_234, _toDisplayString(_ctx.$t("pos.complete_pos_sale_to_view_bill")), 1)
                  ]))
          ]),
          _createElementVNode("div", _hoisted_235, [
            _createElementVNode("button", _hoisted_236, _toDisplayString(_ctx.$t("common.close")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary bill-print-btn",
              onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.printInvoice && _ctx.printInvoice(...args))),
              disabled: _ctx.invoiceLoading || !_ctx.lastSaleData
            }, [
              _cache[62] || (_cache[62] = _createElementVNode("i", { class: "ri-printer-line me-1" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("pos.print_bill")), 1)
            ], 8, _hoisted_237)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_238, [
      _createElementVNode("div", _hoisted_239, [
        _createElementVNode("div", _hoisted_240, [
          _createElementVNode("div", _hoisted_241, [
            _createElementVNode("h5", _hoisted_242, _toDisplayString(_ctx.$t("pos.open_register_title")), 1),
            _cache[63] || (_cache[63] = _createElementVNode("button", {
              type: "button",
              class: "btn-close btn-close-white",
              id: "closeOpenRegisterModal",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_243, [
            _createElementVNode("div", _hoisted_244, [
              _createElementVNode("div", _hoisted_245, [
                _createElementVNode("form", {
                  onSubmit: _cache[35] || (_cache[35] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleOpenRegister && _ctx.handleOpenRegister(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_246, [
                    _createElementVNode("label", _hoisted_247, _toDisplayString(_ctx.$t("pos.opening_balance_cash_in_hand")), 1),
                    _createElementVNode("div", _hoisted_248, [
                      _cache[64] || (_cache[64] = _createElementVNode("span", { class: "input-group-text register-balance-prefix register-balance-prefix-primary fw-bold" }, "$", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        step: "0.01",
                        min: "0",
                        class: "form-control register-balance-input",
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.openingBalance) = $event)),
                        placeholder: "0.00",
                        required: ""
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.openingBalance,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("small", _hoisted_249, _toDisplayString(_ctx.$t("pos.opening_balance_help")), 1)
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary w-100 fw-bold py-2 mt-3",
                    disabled: _ctx.isRegisterSubmitting
                  }, [
                    (_ctx.isRegisterSubmitting)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_251))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("pos.open_register")), 1)
                  ], 8, _hoisted_250),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light w-100 fw-medium py-2 mt-2",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.cancelOpenRegister && _ctx.cancelOpenRegister(...args)))
                  }, _toDisplayString(_ctx.$t("common.cancel")), 1)
                ], 32)
              ]),
              _createElementVNode("div", _hoisted_252, [
                _createElementVNode("h6", _hoisted_253, [
                  _cache[65] || (_cache[65] = _createElementVNode("i", { class: "ri-history-line me-1" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("pos.recent_register_history")), 1)
                ]),
                _createElementVNode("div", _hoisted_254, [
                  _createElementVNode("table", _hoisted_255, [
                    _createElementVNode("thead", _hoisted_256, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("pos.opened_by")), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("pos.opened_at")), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("pos.closed_at")), 1),
                        _createElementVNode("th", _hoisted_257, _toDisplayString(_ctx.$t("pos.balance")), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.registerHistory, (h) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: h.id
                        }, [
                          _createElementVNode("td", null, [
                            (h.user)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_258, _toDisplayString((h.user.first_name || '') + ' ' + (h.user.last_name || '') || h.user.username || '-'), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_259, "-"))
                          ]),
                          _createElementVNode("td", null, _toDisplayString(new Date(h.opened_at).toLocaleString("en-GB", { timeZone: "Asia/Phnom_Penh", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true })), 1),
                          _createElementVNode("td", null, _toDisplayString(h.closed_at ? new Date(h.closed_at).toLocaleString("en-GB", { timeZone: "Asia/Phnom_Penh", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true }) : '-'), 1),
                          _createElementVNode("td", _hoisted_260, "$" + _toDisplayString(Number(h.closing_balance).toFixed(2)), 1)
                        ]))
                      }), 128)),
                      (_ctx.registerHistory.length === 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_261, [
                            _createElementVNode("td", _hoisted_262, _toDisplayString(_ctx.$t("pos.no_history_found")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_263, [
      _createElementVNode("div", _hoisted_264, [
        _createElementVNode("div", _hoisted_265, [
          _createElementVNode("div", _hoisted_266, [
            _createElementVNode("h5", _hoisted_267, _toDisplayString(_ctx.$t("pos.close_register_title")), 1),
            _cache[66] || (_cache[66] = _createElementVNode("button", {
              type: "button",
              class: "btn-close btn-close-white",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[38] || (_cache[38] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleCloseRegister && _ctx.handleCloseRegister(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_268, [
              _createElementVNode("div", _hoisted_269, [
                _createElementVNode("h6", _hoisted_270, _toDisplayString(_ctx.$t("pos.register_summary")), 1),
                _createElementVNode("div", _hoisted_271, [
                  _createElementVNode("span", _hoisted_272, _toDisplayString(_ctx.$t("pos.opening_balance")) + ":", 1),
                  _createElementVNode("span", _hoisted_273, "$" + _toDisplayString(Number(_ctx.currentRegister?.opening_balance || 0).toFixed(2)), 1)
                ]),
                _createElementVNode("div", _hoisted_274, [
                  _createElementVNode("span", _hoisted_275, _toDisplayString(_ctx.$t("pos.cash_payments")) + ":", 1),
                  _createElementVNode("span", _hoisted_276, "+ $" + _toDisplayString(Number(_ctx.currentRegister?.payments_cash || 0).toFixed(2)), 1)
                ]),
                _createElementVNode("div", _hoisted_277, [
                  _createElementVNode("span", _hoisted_278, _toDisplayString(_ctx.$t("pos.bank_payments")) + ":", 1),
                  _createElementVNode("span", _hoisted_279, "+ $" + _toDisplayString(Number(_ctx.currentRegister?.payments_bank || 0).toFixed(2)), 1)
                ]),
                _createElementVNode("div", _hoisted_280, [
                  _createElementVNode("span", _hoisted_281, _toDisplayString(_ctx.$t("pos.total_discount")) + ":", 1),
                  _createElementVNode("span", _hoisted_282, "- $" + _toDisplayString(Number(_ctx.currentRegister?.total_discount || 0).toFixed(2)), 1)
                ]),
                _createElementVNode("div", _hoisted_283, [
                  _createElementVNode("span", _hoisted_284, _toDisplayString(_ctx.$t("pos.expected_balance")) + ":", 1),
                  _createElementVNode("span", _hoisted_285, "$" + _toDisplayString((Number(_ctx.currentRegister?.opening_balance || 0) + Number(_ctx.currentRegister?.payments_cash || 0) + Number(_ctx.currentRegister?.payments_bank || 0) - Number(_ctx.currentRegister?.total_discount || 0)).toFixed(2)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_286, [
                _createElementVNode("label", _hoisted_287, _toDisplayString(_ctx.$t("pos.actual_closing_balance")), 1),
                _createElementVNode("div", _hoisted_288, [
                  _cache[67] || (_cache[67] = _createElementVNode("span", { class: "input-group-text register-balance-prefix register-balance-prefix-danger fw-bold" }, "$", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    step: "0.01",
                    class: "form-control register-balance-input register-balance-input-danger",
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.closingBalance) = $event)),
                    placeholder: "0.00",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.closingBalance]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_289, [
                _createElementVNode("label", _hoisted_290, _toDisplayString(_ctx.$t("pos.note")), 1),
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.closeNote) = $event)),
                  rows: "2",
                  placeholder: _ctx.$t('pos.optional_notes')
                }, null, 8, _hoisted_291), [
                  [_vModelText, _ctx.closeNote]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_292, [
              _createElementVNode("button", _hoisted_293, _toDisplayString(_ctx.$t("common.cancel")), 1),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-danger fw-bold shadow-sm",
                disabled: _ctx.isRegisterSubmitting
              }, [
                (_ctx.isRegisterSubmitting)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_295))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("pos.close_register_end_shift")), 1)
              ], 8, _hoisted_294)
            ])
          ], 32)
        ])
      ])
    ]),
    _cache[69] || (_cache[69] = _createElementVNode("button", {
      id: "triggerOpenRegisterModal",
      type: "button",
      class: "d-none",
      "data-bs-toggle": "modal",
      "data-bs-target": "#openRegisterModal"
    }, null, -1)),
    _cache[70] || (_cache[70] = _createElementVNode("button", {
      id: "triggerCloseRegisterModal",
      type: "button",
      class: "d-none",
      "data-bs-toggle": "modal",
      "data-bs-target": "#closeRegisterModal"
    }, null, -1))
  ]))
}